module.exports = function() {
  return new Worker(__webpack_public_path__ + "0c6e00dc5fa45c0a7234.worker.js");
};